const socialProof = () => (
     <section id="socialProof" class="section-padding trust-bg">
        <div class="container mx-auto px-6 md:px-0 md:w-10/12 lg:w-8/12 xl:w-6/12 text-center">
            <h2 class="text-3xl font-bold mb-8">Built After Speaking With 20+ Marketing Agency Owners</h2>
            <p class="text-xl text-gray-700 mb-8">We designed this service based on real agency pain — chasing late invoices, burning time, and stressing over cash flow. Our system recovers an average of 78% of overdue payments within 30 days.</p>
            <div class="flex justify-center space-x-4">
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <p class="font-bold text-2xl text-blue-600">78%</p>
                    <p class="text-gray-600">Recovery Rate</p>
                </div>
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <p class="font-bold text-2xl text-blue-600">7 days</p>
                    <p class="text-gray-600">Average Setup</p>
                </div>
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <p class="font-bold text-2xl text-blue-600">95%</p>
                    <p class="text-gray-600">Client Retention</p>
                </div>
            </div>
        </div>
    </section>
);

export default socialProof;